import { jsx as _jsx } from "react/jsx-runtime";
import { FieldList } from '@integration-app/react';
import { useFieldMappingInstanceContext } from '../contexts';
export function ImportFieldMappingInstanceConfig() {
    const { fieldMappingInstance, patch } = useFieldMappingInstanceContext();
    const { importValue, dataSourceSchema, appSchema, frozenImportFields } = fieldMappingInstance;
    return (_jsx(FieldList, { value: importValue, schema: appSchema, variablesSchema: dataSourceSchema, frozenFieldsLocators: frozenImportFields, onChange: (importValue) => patch({ importValue }) }));
}
//# sourceMappingURL=ImportFieldMappingInstanceConfig.js.map